const initialState = {
  fetching: false,
  fetched: false,
  updating: false,
  uploadingFile: false,
  error: null,
  data: null,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'PAYOUT_ACCOUNT_CREATE_PENDING':
    case 'PAYOUT_ACCOUNT_UPDATE_PENDING': {
      return {
        ...state,
        updating: true,
      }
    }

    case 'PAYOUT_ACCOUNT_UPDATE_FULFILLED': {
      return {
        ...state,
        updating: false,
        data: action.payload.data,
      }
    }

    case 'PAYOUT_ACCOUNT_CREATE_REJECTED':
    case 'PAYOUT_ACCOUNT_UPDATE_REJECTED': {
      return {
        ...state,
        updating: false,
        error: action.payload.data,
      }
    }

    case 'PAYOUT_ACCOUNT_FETCH_PENDING': {
      return {
        ...state,
        fetching: true,
      }
    }

    case 'PAYOUT_ACCOUNT_FETCH_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload.data,
      }
    }

    case 'PAYOUT_ACCOUNT_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        error: action.payload.data,
      }
    }

    case 'PAYOUT_ACCOUNT_FILE_UPLOAD_PENDING': {
      return {
        ...state,
        uploadingFile: true,
      }
    }

    case 'PAYOUT_ACCOUNT_FILE_UPLOAD_FULFILLED': {
      return {
        ...state,
        uploadingFile: false,
        data: action.payload.data,
      }
    }

    case 'PAYOUT_ACCOUNT_FILE_UPLOAD_REJECTED': {
      return {
        ...state,
        uploadingFile: false,
        error: action.payload.data,
      }
    }

    case 'PAYOUT_ACCOUNT_STRIPE_CREATE_TOKEN_ERROR': {
      return {
        ...state,
        error: action.meta.error,
      }
    }

    default: {
      return state
    }
  }
}
